<template>
  <div class="alerts-block" :class="{ confirm: isConfirm }" v-if="alerts.length > 0">
    <Alert
      v-for="alert in alerts"
      :key="alert.id"
      :id="alert.id"
      :message="alert.message"
      :isGlobal="true"
      :color="alert.color"
      :duration="alert.duration"
      @closed="removeAlert(alert)"
    />
  </div>
</template>

<script>
import Alert from "./Alert.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "AlertManager",
  components: { Alert },
  computed: {
    ...mapState("alerts", ["alerts"]),
    isConfirm() {
      return this.alerts.every((alert) => alert.type === "confirm");
    },
  },
  methods: {
    ...mapActions("alerts", ["removeAlert"]),
  },
};
</script>
